import { Card, CardBody, Col } from "reactstrap";
import { FontSizes } from "../../../../Constant";
import { FONT_SIZE, FONT_SIZES } from "../../../../Data/UiKit/HelperClasses";
import CommonCardHeader from "../../../../Common/CommonCardHeader";

const FontSizesCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={FontSizes} span={FONT_SIZES} />
        <CardBody>
          <div className="gradient-border">
            <div className="font-wrapper border">
              <div className="f-14">Font-size .$f-14</div>
            </div>
            {FONT_SIZE.map((item, index) => (
              <div className="font-wrapper border" key={index}>
                <div className={item}>{`Font-size .${item}`}</div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FontSizesCart;
